module.exports = __webpack_public_path__ + "img/kit A&S.20ff591a.jpg";